<!-- src/components/ParkingModal.vue -->
<template>
  <div class="modal" v-if="visible">
    <div class="modal-content">

      <div class="parking-info">
        <h2>{{ parking.title }}</h2>
        <p class="address">{{ parking.address }}</p>
        <label>支付方式</label>
        <p class="payment-method">

          <!-- {{ parking.payment_method.replace('#$%', ',') }} -->

          {{ getPaymentMethod(parking) }}

        </p>
        <span class="close" @click="closeModal">&times;</span>

      </div>

      <div style="height:24px;"></div>
      <label>繳費方式</label>
      <div style="height:16px;"></div>

      <!-- <button v-if="enableCardDiscount" class="payment-but" @click="proceedToCardDiscount">線上繳費及紅利折抵</button> -->

      <button class="payment-but"
      @click="proceedToCardDiscount">線上繳費及優惠折抵</button>      
      <div style="height:24px;"></div>
      <!-- {{ parking.payment_url }} -->
      <!-- <button class='payment-but' @click="proceedToPayment">前往線上繳費</button> -->
    </div>
  </div>
</template>

<script>
import { getPaymentMethod } from '@/util/util';
export default {
  name: 'ParkingModal',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    parking: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      enableCardDiscount: process.env.VUE_APP_ENABLE_CREDIT_CARD_DISCOUNT === 'true'
    };
  },
  methods: {
    getPaymentMethod,

    closeModal() {
      this.$emit('close');
    },
    proceedToPayment() {
      this.$emit('goOnlinePayment');

    },
    proceedToCardDiscount() {
      this.$emit('cardDiscount');
    }
  },
  mounted() {
    console.log('ENABLE Card DISTOUCNT',process.env.VUE_APP_ENABLE_CREDIT_CARD_DISCOUNT);
   
  }
};
</script>

<style scoped>
.modal {
  flex:1;
  display: flex;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: calc(100vh - 88px);
  /* overflow: auto; */
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);

  z-index: 2000;

}

.modal-content {
  /* position: ; */
  display: flex;
  flex-direction: column;
  background-color: #fefefe;
  align-items: center;
  text-align: center;
  /* margin: 28vh calc(50% - 220px); */
  margin: 200px auto;

  /* padding: 20px; */
  border: 1px solid #888;
  border-radius: 12px;


  width: 440px;
  height: 528px;

  box-sizing: border-box;


}




/* Parking Info Section */
.parking-info {
  position: relative;

  background-color: var(--yellow03);
  /* padding: 20px; */

  width: 440px;
  height: 226px;
  border-radius: 16px 16px 0px 0px;


  display: flex;
  flex-direction: column;
  text-align: center;

}

.parking-info h2 {

  font-family: Inter;
  font-size: 32px;
  font-weight: 700;
  line-height: 43.52px;
  text-align: center;

  margin-top: 32px;
  margin-bottom: 0px;

  color: var(--gray15);

}

.address {
  margin-top: 4px;
  margin-bottom: 32px;

  font-family: Inter;
  font-size: 20px;
  font-weight: 400;
  line-height: 30px;
  text-align: center;

  color: var(--gray15);

}

label {
  margin: 0px;

  font-family: Inter;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: center;

  color: var(--gray11);

}


.payment-method {
  margin-top: 4px;
  margin-bottom: 32px;


  font-family: Inter;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: center;

  color: var(--gray13);

}




.close {
  position: absolute;
  color: #aaa;
  float: right;
  top: 10px;
  right: 10px;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}


.payment-but {
  border: none;
  cursor: pointer;

  width: 320px;
  height: 58px;
  min-width: 320px;
  min-height: 48px;
  padding: 16px 32px 16px 32px;
  border-radius: 99px;


  font-family: Inter;
  font-size: 18px;
  font-weight: 700;
  line-height: 26.1px;
  text-align: center;


  margin-top: 38px;

  background-color: var(--green03);
  color: white;

}


@media screen and (max-width: 560px) {
  .modal-content {
    width: 343px;
    /* height: 100%; */
    /* margin: 0; */
    margin-top:10vh;
    border-radius: 16px;
  }

  .parking-info {
    width: 100%;
    height: 50%;
    border-radius: 16px 16px 0 0 ;
  }

  .payment-but {
    width: 240px;
    min-width: 240px;
  }
  
}

</style>